<template>
  <div id="app">
    <router-view></router-view>
    <share-poster ref="poster" :type="3"></share-poster>
  </div>
</template>
<script>
import SharePoster from '@/summerCamp/components/sharePoster'
import Bus from './utils/bus'
export default {
  name: 'App',
  components: {
    SharePoster
  },
  mounted() {
    // 在这设置app的 setAppTitleBar 路由跳转后不生效
    Bus.$on('share', () => {
      this.$refs.poster.show()
    })
  }
}
</script>
<style lang="less">
#app {
  min-height: 100vh;
  font-family: 'PingFangSC-Regular', 'Microsoft YaHei', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

img {
  width: 100%;
}

/* 消除input自动填充时的背景色 */
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
</style>
